import { createFileRoute } from "@tanstack/react-router";
import { ExportarTabelasSqlPage } from "@/paginas/pg_database/database-sql-exportar-tabelas";

const TITULO = "Exportar dados — Milky Moo Palmares";
const DESCRICAO =
  "Gera um script SQL com os comandos para recriar todos os registros de todas as tabelas do banco.";

export const Route = createFileRoute("/_authenticated/database-sql-exportar-tabelas")({
  head: () => ({
    meta: [
      { title: TITULO },
      { name: "description", content: DESCRICAO },
      { property: "og:title", content: TITULO },
      { property: "og:description", content: DESCRICAO },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: ExportarTabelasSqlPage,
});
